import { render, staticRenderFns } from "./DirectoratePage.vue?vue&type=template&id=2a8c603c&"
import script from "./DirectoratePage.vue?vue&type=script&lang=js&"
export * from "./DirectoratePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DirectoratePage.vue"
export default component.exports